<div class="workflow-dropdown" [class.disabled]="disabled()">
  <!-- Workflow Selector Button -->
  <button 
    class="workflow-selector-btn"
    (click)="toggleDropdown()"
    [disabled]="disabled()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="true"
  >
    <span class="workflow-text">{{ currentWorkflow() }}</span>
    <mat-icon class="dropdown-arrow" [class.open]="isOpen()">arrow_drop_down</mat-icon>
  </button>

  <!-- Custom Dropdown -->
  <div 
    class="dropdown-menu" 
    [class.open]="isOpen()"
    [attr.aria-hidden]="!isOpen()"
    [style.display]="isOpen() ? 'block' : 'none'"
    role="menu"
  >
    <!-- New Workflow Button - Visible to project Owners/Admins on HEAD while holding the lock -->
    @if (canCreateWorkflow()) {
      <div 
        class="dropdown-item new-workflow-btn" 
        (click)="createNewWorkflow()" 
        (keydown)="onKeyDown($event, 'createNewWorkflow')"
        role="menuitem"
        tabindex="0"
      >
        <div class="new-workflow-content">
          <mat-icon class="add-icon">add</mat-icon>
          <span class="new-workflow-text">New Workflow</span>
        </div>
      </div>
    }

    <!-- Divider - Visible to project Owners/Admins on HEAD while holding the lock -->
    @if (canCreateWorkflow()) {
      <div class="dropdown-divider"></div>
    }

    <!-- Workflow List Items -->
    @for (workflow of workflows(); track workflow.workflowId) {
      <div 
        class="dropdown-item workflow-item"
        [class.selected]="isSelectedWorkflow(workflow)"
        [class.active]="isActiveWorkflow(workflow)"
        (click)="selectWorkflow(workflow)"
        (keydown)="onKeyDown($event, 'selectWorkflow', workflow)"
        role="menuitem"
        tabindex="0"
      >
        <div class="workflow-content">
          <div class="workflow-info">
            <div class="workflow-name-row">
              <span class="workflow-name">{{ workflow.name }}</span>
              @if (workflow.headlessOnly) {
                <span class="routine-only-badge">Routine-only</span>
              }
            </div>
            @if (isActiveWorkflow(workflow)) {
              <span class="active-indicator">(Active)</span>
            }
            @if (workflow.createdAt) {
              <span class="workflow-timestamp">from {{ formatTimestamp(workflow.createdAt) }}</span>
            }
          </div>
          <div class="workflow-icons">
            @if (workflow.headlessOnly) {
              <mat-icon class="routine-only-icon" title="Routine-only workflow">schedule</mat-icon>
            }
            @if (isActiveWorkflow(workflow)) {
              <mat-icon class="active-icon" title="Active Workflow">radio_button_checked</mat-icon>
            }
            @if (isSelectedWorkflow(workflow)) {
              <mat-icon class="check-icon">check</mat-icon>
            }
            @if (canDeleteWorkflow()) {
              <button
                class="delete-workflow-btn"
                (click)="deleteWorkflow(workflow, $event)"
                matTooltip="Delete workflow"
                aria-label="Delete workflow"
                type="button"
              >
                <mat-icon class="delete-icon">delete</mat-icon>
              </button>
            }
          </div>
        </div>
      </div>
    }

    <!-- No workflows message -->
    @if (workflows().length === 0) {
      <div class="dropdown-item no-workflows">
        <span class="no-workflows-text">No workflows available</span>
      </div>
    }
  </div>

  <!-- Backdrop -->
  @if (isOpen()) {
    <div 
      class="dropdown-backdrop"
      (click)="closeDropdown()"
      (keydown)="onKeyDown($event, 'closeDropdown')"
      tabindex="0"
    ></div>
  }
</div>
